/**
 * Distance Calculator的Store模块
 */

const state = {
  ports: [], // 保存港口对象的数组
  portList: [],
  uuid: '',
  optionFlag: 0 // 0/1/2(add/del/edit)
}

const mutations = {
  // 添加港口
  addPort (state, payload) {
    state.optionFlag = 0
    state.ports.push(payload)
    // 港口修改后，设置需重新计算标志
    this.commit('distance/setIsGettedDistance', false)
  },
  // 调整港口顺序
  adjustPortOrder (state, { oldIndex, newIndex }) {
    state.optionFlag = 2
    state.ports.splice(newIndex, 0, ...state.ports.splice(oldIndex, 1))
  },
  // 移除某一港
  removeOnePort (state, { no }) {
    state.optionFlag = 1
    state.uuid = no
    const ind = state.ports.findIndex((ele) => {
      return ele.no == no
    })
    state.ports.splice(ind, 1)
  },
  resetUUID (state) {
    state.uuid = ''
  },
  addToPortList (state, payload) {
    state.portList.push(payload)
  },
  // 调整列表中港口速度为同一值
  setPortOneSpeed (state, { speed }) {
    for (let i = 0; i < state.ports.length; i++) {
      state.ports[i].Speed = speed
    }
  },
  // 调整某一港口的航速
  changeOnePortSpeed (state, { speed, index }) {
    state.ports[index].Speed = speed
  },
  initPorts (state) {
    state.ports.forEach((ele) => {
      ele.Distance = 0 // 总航程距离
      ele.SeaDays = 0 // 航行天数
    })
  },
  // 重置State中的数据
  resetPort (state) {
    state.ports = []
    state.portList = []
    state.uuid = ''
  }
}

const actions = {}

export default {
  state,
  actions,
  mutations
}
